export const setOrgListingConfig = (val) => ({
    type: 'SET_ORG_LISTING_CONFIG',
    val
});
